import { render, staticRenderFns } from "./VacancyPage.vue?vue&type=template&id=78f5cfca"
import script from "./VacancyPage.vue?vue&type=script&lang=js"
export * from "./VacancyPage.vue?vue&type=script&lang=js"
import style0 from "./VacancyPage.vue?vue&type=style&index=0&id=78f5cfca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports